import React from "react";
import { Typography, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

interface StyleListItemButtonProps {
  emotion: {
    icon: React.ComponentType;
    name: string;
  };
  id: string;
  isSelected?: boolean;
  onSelect?: () => void;
}

export const StyleListItemButton = ({
  emotion,
  id,
  isSelected = false,
  onSelect,
}: StyleListItemButtonProps): JSX.Element => {
  const IconComponent = emotion.icon;

  return (
    <Box
      id={id}
      onClick={onSelect}
      sx={{
        width: "100%",
        cursor: "pointer",
        backgroundColor: isSelected ? "#ebf7f7" : "white",
        border: isSelected
          ? "1px solid rgba(0, 134, 103, 0.5)"
          : "1px solid transparent",
        transition: "background-color 0.3s, border-color 0.3s",
        padding: 2,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        position: "relative",
        "&:hover": {
          backgroundColor: isSelected ? "#ebf7f7" : "rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <Box sx={{ marginRight: 2, display: "flex", alignItems: "center" }}>
        <IconComponent />
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body1" color="text.primary">
          {emotion.name}
        </Typography>
      </Box>
      {isSelected && (
        <CheckIcon
          color="primary"
          sx={{
            position: "absolute",
            right: 16,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        />
      )}
    </Box>
  );
};

export default StyleListItemButton;
